<template>
  <div class="tags">
    <div>
      &nbsp;<toggle-button v-if="!isEditing" v-bind:isHidden="isHidden" @show="show()" @hide="hide()" />
      <button @click="isHidden?show():hide()" type="button" class="w3-button" style="margin:0px; padding:0px">
        <span style="font-weight:bold">&nbsp;Tags:</span> 
      </button> 
      <edit-button v-if="isEditable" v-bind:isEditing="isEditing" @edit="edit()" @done="stopEdit()" />
    </div>
    <input v-if="isEditing" @keyup.enter="$emit('addTag')" @blur="$emit('addTag')" type="text" name="tags" placeholder="TAG" v-model="model.meta.newTag" class="w3-margin-bottom">
    <span v-if="!isHidden || isEditing" v-for="(tag) in tags" class="w3-tag w3-medium w3-theme-d5 w3-margin-right w3-margin-bottom"> 
      {{tag}}<a v-if="isEditing" @click="$emit('removeTag', tag)" type="button" class="w3-theme-d5" style="margin-left:5px">X</a>
    </span>
  </div>
</template>

<script>
  import Tags from "./Tags.ts";

  export default Tags;
</script>
